import { get, post, destroy } from '.';

export function GetLoyaltySegments(options = {}) {
	return get<any>('/app/api/loyalty_segments', options);
}

export function CreateLoyaltySegment(options = {}) {
	return post<any>('/app/api/loyalty_segments', options);
}

export function DestroyLoyaltySegment(id: number | string) {
	return destroy<any>(`/app/api/loyalty_segments/${id}`);
}
